import { Api } from 'api';
import { Dispatch } from 'redux';
import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { ApplicationState } from 'redux/applicationState';
import { FirmsActions } from 'redux/reducers/firmsReducer';

export const getFirmsTypes =
  () =>
  (dispatch: Dispatch<Action<FirmsActions>>, _: () => ApplicationState, api: Api): VoidFunction => {
    dispatch(createAction(FirmsActions.getFirmsTypesStarted));
    const task = api.getFXOFirmsTypes();

    task
      .run()
      .then((firmsTypes: readonly string[]): void => {
        dispatch(createAction(FirmsActions.getFirmsTypesCompleted, firmsTypes));
      })
      .catch((error: any): void => {
        dispatch(createAction(FirmsActions.getFirmsTypesFailed, error));
      });

    return (): void => {
      task.cancel();
    };
  };
